import { styled } from "@mui/material/styles";

export const LocationMismatchStyled = styled("div")(() => ({
  "& .timer": {
    color: "#3E73A4",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    // width: "480px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    margin: "5px 0px",
    wordBreak: "break-word",
  },
  "& .detail": {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "19.36px",
    color: "var(--tex, #989696)",
    margin: "5px",
    fontFamily: "Poppins",
    overflowX: "hidden",
    textOverflow: "ellipsis",
    // width: "65%",
  },
  "& .detail p": {
    margin: "0",
  },
  "& .secure-data-layout": {
    display: "flex",
  },
  "& .secure": {
    marginLeft: "12px",
    textTransform: "capitalize",
  },
}));
